import React from "react";

export const IconStage = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m15.85 2.75c0.7594 0 1.375-0.61561 1.375-1.375 0-0.75939-0.6156-1.375-1.375-1.375s-1.375 0.61561-1.375 1.375c0 0.75939 0.6156 1.375 1.375 1.375z"
      fill="#000"
    />
    <path
      d="m1 21.542h22m-5.3167-18.333v18.333m-1.1-19.433 3.4834 3.4833m-15.033 15.95v-9.9917c0-0.55 0.45833-1.1 1.1-1.1h3.85c0.55004 0 1.1 0.4583 1.1 1.1v9.9917h-6.05z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="m8.0583 18.517c0.50626 0 0.91667-0.4104 0.91667-0.9167s-0.41041-0.9167-0.91667-0.9167-0.91667 0.4104-0.91667 0.9167 0.41041 0.9167 0.91667 0.9167z"
      fill="#000"
    />
    <path
      d="m8.0584 15.767c0.75939 0 1.375-0.6156 1.375-1.375s-0.61561-1.375-1.375-1.375-1.375 0.6156-1.375 1.375 0.61561 1.375 1.375 1.375z"
      fill="#000"
    />
  </svg>
);

export default IconStage;
